import { render } from "./DocumentationPage.vue?vue&type=template&id=c7bfcd6a&scoped=true&ts=true"
import script from "./DocumentationPage.vue?vue&type=script&lang=ts"
export * from "./DocumentationPage.vue?vue&type=script&lang=ts"

import "./DocumentationPage.vue?vue&type=style&index=0&id=c7bfcd6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7bfcd6a"]])

export default __exports__